import useReveal from "../hooks/useReveal";
import { Search, Compass, TrendingUp } from "lucide-react";

const STEPS = [
    {
        n: "01",
        icon: Search,
        title: "We diagnose your freight",
        body: "Bring 90 days of invoices, lanes and forwarder data. We map every leak, surcharge and visibility gap.",
        testid: "how-step-1",
    },
    {
        n: "02",
        icon: Compass,
        title: "We design the fix",
        body: "Cost controls, carrier strategy, procurement benchmarks and visibility setup — tailored to your trade.",
        testid: "how-step-2",
    },
    {
        n: "03",
        icon: TrendingUp,
        title: "We deliver continuous gain",
        body: "Each shipment becomes a feedback loop. Audit, learn, adjust — month after month.",
        testid: "how-step-3",
    },
];

export default function HowItWorks() {
    const [ref, visible] = useReveal();
    return (
        <section
            id="how-it-works"
            data-testid="how-it-works-section"
            className="relative border-t border-white/5 py-20 sm:py-28"
        >
            <div ref={ref} className={`reveal ${visible ? "is-visible" : ""} max-w-7xl mx-auto px-4 sm:px-6 lg:px-8`}>
                <div className="max-w-2xl mb-14">
                    <span className="section-tag">How it works</span>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white mt-5 leading-tight">
                        Three steps from blind to <span className="text-glow-cyan">in control</span>.
                    </h2>
                </div>

                <div className="grid lg:grid-cols-3 gap-5 lg:gap-6 relative">
                    {/* Connecting line */}
                    <div
                        aria-hidden
                        className="hidden lg:block absolute top-12 left-[8%] right-[8%] h-px"
                        style={{
                            background: "linear-gradient(90deg, transparent, rgba(0,240,255,0.35), transparent)",
                        }}
                    />
                    {STEPS.map((s) => (
                        <div
                            key={s.n}
                            data-testid={s.testid}
                            className="card-glow rounded-2xl p-7 lg:p-8 relative"
                        >
                            <div className="flex items-center justify-between mb-7">
                                <div
                                    className="w-12 h-12 rounded-xl flex items-center justify-center"
                                    style={{
                                        background: "rgba(0,240,255,0.08)",
                                        border: "1px solid rgba(0,240,255,0.3)",
                                    }}
                                >
                                    <s.icon size={22} className="text-cyan-300" />
                                </div>
                                <span
                                    className="font-display text-5xl tracking-tighter"
                                    style={{
                                        background:
                                            "linear-gradient(180deg, rgba(255,255,255,0.10), rgba(255,255,255,0.02))",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    {s.n}
                                </span>
                            </div>
                            <h3 className="font-display text-xl sm:text-2xl text-white tracking-tight">
                                {s.title}
                            </h3>
                            <p className="text-zinc-400 mt-3 text-sm leading-relaxed">{s.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
